import "./unauthorize.css";
import * as React from "react";
import { Container } from "reactstrap";

export class Unauthorize extends React.Component {
    render() {
        return (
            <Container>
                <h1 className="title">Unauthorized Access</h1>
                <p>Contact System Administrator for more information.</p>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/errors/unauthorize.tsx